import React from 'react';
import Button from '../Button';
import Anchor from '../link/Anchor';
import { SearchTriggerStyle } from './style';

interface SearchListTriggerProps<T> {
  value?: T | null;
  triggerText: string;
  linkText: string;
  subText?: string;
  onClick: () => void;
}

const SearchListTrigger = <T extends object>(props: SearchListTriggerProps<T>) => {
  const { value, subText, linkText, onClick, triggerText } = props;
  return (
    <SearchTriggerStyle>
      {value ? (
        <div>
          <Anchor isUnderLine color="primary" onClick={onClick} text={linkText} />
          {subText && <div>{subText}</div>}
        </div>
      ) : (
        <Button text={triggerText} type="button" color="primary" onClick={onClick} />
      )}
    </SearchTriggerStyle>
  );
};

export default SearchListTrigger;
